module.exports = __webpack_public_path__ + "static/cbpp-8be3691157e24cd93df68e46e7cc5db2.png";